import { render, staticRenderFns } from "./PartnerManagement.vue?vue&type=template&id=b3265dce"
import script from "./PartnerManagement.vue?vue&type=script&lang=ts"
export * from "./PartnerManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports